import { SkeletonBox, SkeletonText, SkeletonCircle } from '../primitives';
import '../primitives/Skeletons.css';

const Bubble = ({ self = false, lines, height }) => (
  <div
    style={{
      display: 'flex',
      justifyContent: self ? 'flex-end' : 'flex-start',
      gap: 'var(--space-sm)',
      alignItems: 'flex-end',
    }}
  >
    {!self && <SkeletonCircle size={32} />}
    <div
      style={{
        maxWidth: '70%',
        padding: 'var(--space-md)',
        borderRadius: self ? '20px 20px 4px 20px' : '20px 20px 20px 4px',
        background: self ? 'var(--color-surface-strong)' : 'var(--color-surface-subtle)',
        border: '1px solid var(--color-border-subtle)',
      }}
    >
      {height ? (
        <SkeletonBox height={height} borderRadius="var(--radius-sm)" />
      ) : (
        <SkeletonText lines={lines.length} widths={lines} lineHeight="14px" gap="0.5rem" />
      )}
    </div>
    {self && <SkeletonCircle size={32} />}
  </div>
);

const PublicChatSkeleton = () => (
  <div
    aria-hidden="true"
    style={{
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '760px',
      margin: '0 auto',
      height: '100%',
      padding: 'var(--space-xl)',
      gap: 'var(--space-md)',
    }}
  >
    {/* Header */}
    <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)' }}>
      <SkeletonCircle size={32} />
      <SkeletonText widths={['160px']} lineHeight="18px" />
    </div>

    {/* Messages */}
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-md)', flex: 1 }}>
      <Bubble lines={['100%', '88%']} />
      <Bubble self lines={['64%']} />
      <Bubble lines={['100%', '92%', '76%']} />
      <Bubble self lines={['80%', '40%']} />
      <Bubble lines={['100%', '60%']} />
    </div>

    {/* Composer */}
    <div
      style={{
        display: 'flex',
        gap: 'var(--space-sm)',
        padding: 'var(--space-sm)',
        borderRadius: '999px',
        border: '1px solid var(--color-border)',
        background: 'var(--color-surface)',
        alignItems: 'center',
      }}
    >
      <SkeletonBox height={40} borderRadius="999px" style={{ flex: 1 }} />
      <SkeletonCircle size={40} />
    </div>
  </div>
);

export default PublicChatSkeleton;
